import { memo } from "react";
import { Box } from "@mui/material";
import {
  CierreContenedor,
  Documentos,
  PanelExterior,
  SelloNaviera,
  SellosSalidaExporbananas,
  SellosSalidaVerificadora, 
  Siglas,
} from "./components";
import { CajasConsolidadas } from "./components/libs/carga-interior";
import type { CollapseProps } from "antd";
import { Collapse, ConfigProvider } from "antd";

interface ThirdComponentPropsI {
  activeKey: any;
  setActiveKey: (key: any) => void;
  width: string;
}

export const ThirdComponent = memo(
  ({ activeKey, setActiveKey, width }: ThirdComponentPropsI) => {


    const items: CollapseProps["items"] = [
      {
        key: "1",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SIGLAS
          </p>
        ),
        children: <Siglas />,
      },
      {
        key: "2",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            CAJAS CONSOLIDADAS
          </p>
        ),
        children: <CajasConsolidadas  widthFull={width} />,
      },
      {
        key: "3",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS SALIDA VERIFICADORA
          </p>
        ),
        children: <SellosSalidaVerificadora />,
      },
      {
        key: "4",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLOS SALIDA EXPORTADORA
          </p>
        ),
        children: <SellosSalidaExporbananas />,
      },
      {
        key: "5",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            SELLO NAVIERA
          </p>
        ),
        children: <SelloNaviera />,
      },
      {
        key: "6",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            DOCUMENTOS
          </p>
        ),
        children: <Documentos />,
      },
      {
        key: "7",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            CIERRE DE CONTENEDOR
          </p>
        ),
        children: <CierreContenedor />,
      },
      {
        key: "8",
        label: (
          <p style={{ color: "navy", fontWeight: "bolder", fontSize: 12 }}>
            PANEL EXTERIOR
          </p>
        ),
        children: <PanelExterior />,
      },
    ];

    return (
      <Box
        sx={{
          minHeight: `calc(100vh - 120px)`,
          maxHeight: `calc(100vh - 120px)`,
          height: `calc(100vh - 120px)`,
          overflowY: "auto",
          m: 0,
          overflowX: "hidden",
          position: "relative",
          pt: 5,
          minWidth: "100%",
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Collapse: {
                contentPadding: "0px",
              },
            },
            token: {
              motionDurationSlow: "0.1s",
              motionDurationMid: "0.1s",
            },
          }}
        >
          <Collapse
            style={{
              width: "100%",
              minWidth: "100%",
            }}
            accordion={true}
            expandIconPosition="end"
            items={items}
            bordered={false}
            destroyInactivePanel={true}
            activeKey={activeKey}
            onChange={(key: string[] | string) => {
              setActiveKey!(key as string[]);
            }}
          />
        </ConfigProvider>
      </Box>
    );
  }
);
